<template>
    <div class='widget'>
        <div class='content' v-if="item">
            <card-view 
                v-if='front' 
                :cardId="item.cardId"
                :html='info.frontHtml' 
                :css='info.frontCss' 
                :fieldSets='item.fieldSets' 
                :fields='item.fields' 
                :front='true'
                :translations='i18n'
                :name='item.name'
                @show-answer='front=false'
                @save-user-field="saveUserField"
                @save-image="saveImage"
                 />
            <card-view 
                v-if='!front' 
                ref="card2"
                :cardId="item.cardId"
                :html='info.backHtml' 
                :css='info.backCss' 
                :fieldSets='item.fieldSets' 
                :fields='item.fields' 
                :front='false' 
                :translations='i18n'
                :name='item.name'
                @know='know'
                @save-user-field="saveUserField"
                @save-image="saveImage"
                />
        </div>
        <div v-else>
            Card not found
        </div>
    </div>
</template>

<script>
import baseMinigame from '../baseMinigame';
import CardView from '@root/lk/views/card-view.vue';
import trustedChannel from '@root/untrusted/trustedChannel';

export default {
    mixins: [baseMinigame],
    components: {
        CardView,
    },
    data() {
        return {
            front: true,
        }
    },
    emits: ["setAnswer"],
    props: ["item"],
    beforeMount() {
        this.autoAnswer = true;
        console.log("Item", this.item);
        console.log("Info", this.info);
        trustedChannel.onMessage("saveImage", command => {
            console.log('image saved', command.url);
            const card2 = this.$refs.card2;
            if (card2) {
                card2.onImageSaved(command);
            }
        });
    },
    methods: {
        know(how) {
            this.setAnswer(+how);
            this.sendAnswer();
            //this.continueStudy();
        },
        validate(){
            return this.answer > 0;
        },        
    },
}
</script>


<style lang="scss" scoped>
    @import 'gameTypes';

    .widget {
        flex: 1 1;
        display: flex;
        flex-direction: column;
        background: rgba(255,255,255,0.7);
    }
    .content {
        flex: 1 1;
        display: flex;
    }

    .card-view {
        flex: 1 1;        
    }
</style>
